const associateTypes = {
    1: 'singular',
    2: 'estrangeiro',
    3: 'estudante',
    4: 'coletivo',
    5: 'associacao',
    6: 'coletivoouro',
    7: 'coletivoplatina'
};

const associateStates = {
    1: 'corrente',
    2: 'histórico'
};

const leavingReasons = [ 'F', 'NRP', 'PD' ];

const regions = [
    'Norte',
    'Centro',
    'Tejo',
    'Sul',
    'Açores',
    'Madeira',
    'Estrangeiro'
];

const paymentMethods = [
    'Cheque',
    'Débito directo',
    'Numerário',
    'Transferência bancária',
    'Outro'
];

const countriesList = [
    { id: 4, name: 'Afeganistão' },
    { id: 8, name: 'Albânia' },
    { id: 10, name: 'Antárctica' },
    { id: 12, name: 'Argélia' },
    { id: 16, name: 'Samoa Americana' },
    { id: 20, name: 'Andorra' },
    { id: 24, name: 'Angola' },
    { id: 28, name: 'Antígua e Barbuda' },
    { id: 31, name: 'Azerbeijão' },
    { id: 32, name: 'Argentina' },
    { id: 36, name: 'Austrália' },
    { id: 40, name: 'Áustria' },
    { id: 44, name: 'Bahamas' },
    { id: 48, name: 'Barém' },
    { id: 50, name: 'Bangladesh' },
    { id: 51, name: 'Arménia' },
    { id: 52, name: 'Barbados' },
    { id: 56, name: 'Bélgica' },
    { id: 60, name: 'Bermudas' },
    { id: 64, name: 'Butão' },
    { id: 68, name: 'Bolívia' },
    { id: 70, name: 'Bósnia-Herzegovina' },
    { id: 72, name: 'Botswana' },
    { id: 74, name: 'Ilha Bouvet' },
    { id: 76, name: 'Brasil' },
    { id: 84, name: 'Belize' },
    { id: 86, name: 'Território Britânico do Oceano Índico' },
    { id: 90, name: 'Ilhas Salomão' },
    { id: 92, name: 'Ilhas Virgens Britânicas' },
    { id: 96, name: 'Brunei' },
    { id: 100, name: 'Bulgária' },
    { id: 104, name: 'Myanmar' },
    { id: 108, name: 'Burundi' },
    { id: 112, name: 'Bielorússia' },
    { id: 116, name: 'Camboja' },
    { id: 120, name: 'Camarões' },
    { id: 124, name: 'Canadá' },
    { id: 132, name: 'Cabo Verde' },
    { id: 136, name: 'Ilhas Caimão' },
    { id: 140, name: 'República Centro-Africana' },
    { id: 144, name: 'Sri Lanka' },
    { id: 148, name: 'Chade' },
    { id: 152, name: 'Chile' },
    { id: 156, name: 'China' },
    { id: 158, name: 'Taiwan' },
    { id: 162, name: 'Ilha Christmas' },
    { id: 166, name: 'Ilhas Cocos' },
    { id: 170, name: 'Colômbia' },
    { id: 174, name: 'Comores' },
    { id: 175, name: 'Mayotte' },
    { id: 178, name: 'Congo-Brazzaville' },
    { id: 180, name: 'Congo-Kinshasa' },
    { id: 184, name: 'Ilhas Cook' },
    { id: 188, name: 'Costa Rica' },
    { id: 191, name: 'Croácia' },
    { id: 192, name: 'Cuba' },
    { id: 196, name: 'Chipre' },
    { id: 203, name: 'República Checa' },
    { id: 204, name: 'Benin' },
    { id: 208, name: 'Dinamarca' },
    { id: 212, name: 'Domínica' },
    { id: 214, name: 'República Dominicana' },
    { id: 218, name: 'Equador' },
    { id: 222, name: 'El Salvador' },
    { id: 226, name: 'Guiné Equatorial' },
    { id: 231, name: 'Etiópia' },
    { id: 232, name: 'Eritreia' },
    { id: 233, name: 'Estónia' },
    { id: 234, name: 'Ilhas Faroé' },
    { id: 238, name: 'Ilhas Malvinas' },
    { id: 239, name: 'Geórgia do Sul e Ilhas Sandwich' },
    { id: 242, name: 'Ilhas Fiji' },
    { id: 246, name: 'Finlândia' },
    { id: 248, name: 'Ilhas Aland' },
    { id: 250, name: 'França' },
    { id: 254, name: 'Guiana Francesa' },
    { id: 258, name: 'Polinésia Francesa' },
    { id: 260, name: 'Territórios Franceses do Sul' },
    { id: 262, name: 'Jibuti' },
    { id: 266, name: 'Gabão' },
    { id: 268, name: 'Geórgia' },
    { id: 270, name: 'Gâmbia' },
    { id: 275, name: 'Palestina' },
    { id: 276, name: 'Alemanha' },
    { id: 288, name: 'Gana' },
    { id: 292, name: 'Gibraltar' },
    { id: 296, name: 'Kiribati' },
    { id: 300, name: 'Grécia' },
    { id: 304, name: 'Gronelândia' },
    { id: 308, name: 'Granada' },
    { id: 312, name: 'Guadalupe' },
    { id: 316, name: 'Guam' },
    { id: 320, name: 'Guatemala' },
    { id: 324, name: 'Guiné' },
    { id: 328, name: 'Guiana' },
    { id: 332, name: 'Haiti' },
    { id: 334, name: 'Ilha Heard e Ilhas McDonald' },
    { id: 336, name: 'Santa Sé' },
    { id: 340, name: 'Honduras' },
    { id: 344, name: 'Hong Kong' },
    { id: 348, name: 'Hungria' },
    { id: 352, name: 'Islândia' },
    { id: 356, name: 'Índia' },
    { id: 360, name: 'Indonésia' },
    { id: 364, name: 'Irão' },
    { id: 368, name: 'Iraque' },
    { id: 372, name: 'Irlanda' },
    { id: 376, name: 'Israel' },
    { id: 380, name: 'Itália' },
    { id: 384, name: 'Costa do Marfim' },
    { id: 388, name: 'Jamaica' },
    { id: 392, name: 'Japão' },
    { id: 398, name: 'Cazaquistão' },
    { id: 400, name: 'Jordânia' },
    { id: 404, name: 'Quénia' },
    { id: 408, name: 'Coreia do Sul' },
    { id: 410, name: 'Coreia do Norte' },
    { id: 414, name: 'Kuwait' },
    { id: 417, name: 'Quirguizistão' },
    { id: 418, name: 'Laos' },
    { id: 422, name: 'Líbano' },
    { id: 426, name: 'Lesoto' },
    { id: 428, name: 'Letónia' },
    { id: 430, name: 'Libéria' },
    { id: 434, name: 'Líbia' },
    { id: 438, name: 'Liechtenstein' },
    { id: 440, name: 'Lituânia' },
    { id: 442, name: 'Luxemburgo' },
    { id: 446, name: 'Macau' },
    { id: 450, name: 'Madagáscar' },
    { id: 454, name: 'Malawi' },
    { id: 458, name: 'Malásia' },
    { id: 462, name: 'Maldivas' },
    { id: 466, name: 'Mali' },
    { id: 470, name: 'Malta' },
    { id: 474, name: 'Martinica' },
    { id: 478, name: 'Mauritânia' },
    { id: 480, name: 'Maurícias' },
    { id: 484, name: 'México' },
    { id: 492, name: 'Mónaco' },
    { id: 496, name: 'Mongólia' },
    { id: 498, name: 'Moldávia' },
    { id: 500, name: 'Monserrate' },
    { id: 504, name: 'Marrocos' },
    { id: 508, name: 'Moçambique' },
    { id: 512, name: 'Omã' },
    { id: 516, name: 'Namíbia' },
    { id: 520, name: 'Nauru' },
    { id: 524, name: 'Nepal' },
    { id: 528, name: 'Países Baixos' },
    { id: 530, name: 'Antilhas Holandesas' },
    { id: 533, name: 'Aruba' },
    { id: 540, name: 'Nova Caledónia' },
    { id: 548, name: 'Vanuatu' },
    { id: 554, name: 'Nova Zelândia' },
    { id: 558, name: 'Nicarágua' },
    { id: 562, name: 'Níger' },
    { id: 566, name: 'Nigéria' },
    { id: 570, name: 'Niue' },
    { id: 574, name: 'Ilha Norfolk' },
    { id: 578, name: 'Noruega' },
    { id: 580, name: 'Ilhas Marianas do Norte' },
    { id: 581, name: 'Ilhas Menores Distantes dos Estados Unidos' },
    { id: 583, name: 'Micronésia' },
    { id: 584, name: 'Ilhas Marshall' },
    { id: 585, name: 'Palau' },
    { id: 586, name: 'Paquistão' },
    { id: 591, name: 'Panamá' },
    { id: 598, name: 'Papuásia-Nova Guiné' },
    { id: 600, name: 'Paraguai' },
    { id: 604, name: 'Perú' },
    { id: 608, name: 'Filipinas' },
    { id: 612, name: 'Pitcairn' },
    { id: 616, name: 'Polónia' },
    { id: 620, name: 'Portugal' },
    { id: 624, name: 'Guiné-Bissau' },
    { id: 626, name: 'Timor Leste' },
    { id: 630, name: 'Porto Rico' },
    { id: 634, name: 'Catar' },
    { id: 638, name: 'Reunião' },
    { id: 642, name: 'Roménia' },
    { id: 643, name: 'Rússia' },
    { id: 646, name: 'Ruanda' },
    { id: 654, name: 'Santa Helena' },
    { id: 659, name: 'São Cristóvão e Nevis' },
    { id: 660, name: 'Anguila' },
    { id: 662, name: 'Santa Lúcia' },
    { id: 666, name: 'São Pedro e Miquelon' },
    { id: 670, name: 'São Vicente e Grenadinas' },
    { id: 674, name: 'São Marino' },
    { id: 678, name: 'São Tomé and Príncipe' },
    { id: 682, name: 'Arábia Saudita' },
    { id: 686, name: 'Senegal' },
    { id: 690, name: 'Seychelles' },
    { id: 694, name: 'Serra Leoa' },
    { id: 702, name: 'Singapura' },
    { id: 703, name: 'Eslováquia' },
    { id: 704, name: 'Vietname' },
    { id: 705, name: 'Eslovénia' },
    { id: 706, name: 'Somália' },
    { id: 710, name: 'África do Sul' },
    { id: 716, name: 'Zimbabwe' },
    { id: 724, name: 'Espanha' },
    { id: 732, name: 'Sara Ocidental' },
    { id: 736, name: 'Sudão' },
    { id: 740, name: 'Suriname' },
    { id: 744, name: 'Svalbard e a Ilha de Jan Mayen' },
    { id: 748, name: 'Suazilândia' },
    { id: 752, name: 'Suécia' },
    { id: 756, name: 'Suiça' },
    { id: 760, name: 'Síria' },
    { id: 762, name: 'Tajiquistão' },
    { id: 764, name: 'Tailândia' },
    { id: 768, name: 'Togo' },
    { id: 772, name: 'Tokelau' },
    { id: 776, name: 'Tonga' },
    { id: 780, name: 'Trindade e Tobago' },
    { id: 784, name: 'Emiratos Árabes Unidos' },
    { id: 788, name: 'Tunísia' },
    { id: 792, name: 'Turquia' },
    { id: 795, name: 'Turquemenistão' },
    { id: 796, name: 'Ilhas Turcas e Caicos' },
    { id: 798, name: 'Tuvalu' },
    { id: 800, name: 'Uganda' },
    { id: 804, name: 'Ucrânia' },
    { id: 807, name: 'Macedónia' },
    { id: 818, name: 'Egipto' },
    { id: 826, name: 'Reino Unido' },
    { id: 834, name: 'Tanzânia' },
    { id: 840, name: 'Estados Unidos' },
    { id: 850, name: 'Ilhas Virgens Americanas' },
    { id: 854, name: 'Burkina Faso' },
    { id: 858, name: 'Uruguai' },
    { id: 860, name: 'Usbequistão' },
    { id: 862, name: 'Venezuela' },
    { id: 876, name: 'Wallis e Futuna' },
    { id: 882, name: 'Samoa' },
    { id: 887, name: 'Iémen' },
    { id: 891, name: 'Sérvia e Montenegro' },
    { id: 894, name: 'Zâmbia' },
    { id: 895, name: 'Outro' }
];

export {
    associateTypes,
    associateStates,
    leavingReasons,
    regions,
    paymentMethods,
    countriesList
};